import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormatNumPipe } from '@innovation-os-ng/ui/utils';
import { TranslateModule } from '@itonics/ngx-translate-simple';
import { CountryCodes } from '../../../common/helpers/country-codes';
import { WorldMapCategoryMap, WorldMapCountry } from '../../models/worldmap-model';

@Component({
  selector: 'chart-worldmap-tooltip',
  templateUrl: './worldmap-tooltip.component.html',
  styleUrls: ['./worldmap-tooltip.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, FormatNumPipe]
})
export class WorldmapTooltipComponent {
  @Input()
  country: WorldMapCountry;

  @Input()
  categoryMap: WorldMapCategoryMap;

  public countriesMap = CountryCodes;
}
